import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const resolvePriceMemo = createApi('pricememo', 'POST');

const Resolve = createSlice({
  name: 'Resolve',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(resolvePriceMemo.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(resolvePriceMemo.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(resolvePriceMemo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default Resolve.reducer;